var o = "1.7.7";
export { o as VERSION };
